import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styles from "./WWGNews.module.css";
import Toggler from "../components/Toggler";
import Header from "../components/Header";
import Loader from "components/Loader";

import { useWWGNews } from "./useWWGNews";
import { useTranslation } from "react-i18next";

export function WWGNews() {
  const {t} = useTranslation();
  const history = useHistory();

  const { data, isError, isLoading, refetch, updateNewsSettings } =
    useWWGNews();

  const [allowToPost, setAllowToPost] = useState(false);

  useEffect(() => {
    if (data !== undefined) {
      setAllowToPost(data === "True");
    }
  }, [data]);

  async function handleAuthToggle() {
    const allowData = {
      allow: !allowToPost,
    };
    try {
      await updateNewsSettings.mutateAsync(allowData);
    } catch (error) {
      console.error(t("Error updating news settings"), error);
    }
  }

  const handleHeaderBackClick = () => {
    history.push("/");
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Header header={t("Settings")} onClick={handleHeaderBackClick} />
      </div>
      {isLoading ? (
        <div>
          <Loader color={"#415364"} size={85} />
        </div>
      ) : (
        <div className="content">
          <p className={styles.permission}>{t("Permissions")}</p>

          <div className={styles.toggleContainer}>
            <div className={styles.toggle}>
              <p className={styles.text}>{t("Allow WWG to post to my groups")}</p>
              <Toggler
                toggled={allowToPost}
                color={allowToPost ? "#39B54A" : "#D3D3D3"}
                visible={true}
                readOnly={false}
                disabled={false}
                onChange={handleAuthToggle}
              />
            </div>
            {!allowToPost && (
              <p className={styles.description}>
                {t("By unselecting this option you are responsible")}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
